module.exports = __webpack_public_path__ + "static/img/c4aa164d9b01387a88228c67620f7faf861b5544.b67d7132.png";